import React, { useState } from "react";
import arrowIcon from "../../images/menuListIcons/arrow-icon.svg";
import ruFlag from "../../images/flag-icons/flag-ru-icon.svg";
import uaFlag from "../../images/flag-icons/flag-ua-icon.svg";
import "./langSelector.scss";

const LangSelector = () => {
    const [showLanguagesList, setShowLanguagesList] = useState(false);

    return (
        <>
            <div className="lang-selector">
                <div className="lang-selector__button" onClick={() => setShowLanguagesList(!showLanguagesList)}>
                    <img src={uaFlag} alt="arrow" className="lang-seletor__flag" />
                    <div className="lang-seletor__title">UA</div>
                    <img src={arrowIcon} alt="arrow" className="lang-seletor__arrow" />
                </div>
                {showLanguagesList && (
                    <div className="lang-selector__drop-down">
                        <div className="lang-selector__drop-down-item">
                            <img src={ruFlag} alt="arrow" className="lang-seletor__flag" />
                            <div className="lang-seletor__title">RU</div>
                        </div>
                        <div className="lang-selector__drop-down-item">
                            <img src={uaFlag} alt="arrow" className="lang-seletor__flag" />
                            <div className="lang-seletor__title">UA</div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default LangSelector;
